import React from "react";

import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
} from '@material-ui/core';
import { StringParam, useQueryParams } from "use-query-params";



const UserFilters: React.FC = () => {

  const [ filters, setFilters ] = useQueryParams({
    gender: StringParam,
    status: StringParam,
    sortBy: StringParam,
  });



  const handleFilterChange = (event: SelectChangeEvent<string>) => {
    setFilters({
      [ event.target.name ]: event.target.value
    }, 'replaceIn');
  };


  return (
    <Stack direction="row" spacing={2}>

      <FormControl sx={{ minWidth: 80 }}>
        <InputLabel id="gender-label">Gender</InputLabel>
        <Select
          name="gender"
          labelId="gender-label"
          value={filters.gender || 'all'}
          label="Gender"
          onChange={handleFilterChange}
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="male">Male</MenuItem>
          <MenuItem value="female">Female</MenuItem>
        </Select>
      </FormControl>

      <FormControl sx={{ minWidth: 80 }}>
        <InputLabel id="status-label">Status</InputLabel>
        <Select
          name="status"
          labelId="status-label"
          value={filters.status || 'all'}
          label="Status"
          onChange={handleFilterChange}
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="active">Active</MenuItem>
          <MenuItem value="deleted">Deleted</MenuItem>
          <MenuItem value="disabled">Disabled</MenuItem>
        </Select>
      </FormControl>

      <FormControl sx={{ minWidth: 80 }}>
        <InputLabel id="sort-label">Sort</InputLabel>
        <Select
          name="sortBy"
          labelId="sort-label"
          value={filters.sortBy || 'createTime'}
          label="Sort"
          onChange={handleFilterChange}
        >
          <MenuItem value="createTime">Create Time</MenuItem>
          <MenuItem value="lastActiveTimeInternal">Last Active</MenuItem>
        </Select>
      </FormControl>

    </Stack>
  );
};

export default UserFilters;